



let userid = '-1'
let uname = 'qdlkd'
let upwd = ''
let IMEI = ''
let password = ''
let logined = false
export default {
name: 'bus',
userid,
uname,
upwd,
IMEI,
password,
logined
}



// WEBPACK FOOTER //
// ./src/bus.vue